import React from 'react';

interface IMenuItemProps {
    text: string,
    active: boolean,
    pageName: string,
    anchorName?: string,
    onMenuItemClick?: ((sender: MenuItem, page: string, anchor?: string) => void),
}

interface IMenuItemState  {
    active: boolean
}

export default class MenuItem extends React.Component<IMenuItemProps, IMenuItemState> {

    public constructor(props: IMenuItemProps) {
        super(props);
        this.state = {
            active: this.props.active
        };
        this.handleClick = this.handleClick.bind(this);
    }

    public componentWillReceiveProps(nextProps: IMenuItemProps) {
        this.setState({ active: nextProps.active });
    }

    private handleClick(e: React.MouseEvent<HTMLElement>) {
        e.preventDefault();
        this.props.onMenuItemClick && this.props.onMenuItemClick(this, this.props.pageName, this.props.anchorName);
    }

    public render() {
        return (
            <li className={(this.state.active ? "active " : "")} onClick={this.handleClick}>
               {this.props.text}
            </li>
        );
    }
}